import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Upload } from 'app/uploads/shared/upload';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { UserService } from 'app/users/shared/user.service';
import { AngularFireList } from 'angularfire2/database';
import { DateService } from 'app/date/date.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';

@Component({
  selector: 'app-manage-driver',
  templateUrl: './manage-driver.component.html',
  styleUrls: ['./manage-driver.component.css'],
  providers:[NotificationToastService, AngularFireDatabase, DateService]
})
export class ManageDriverComponent implements OnInit {

  private myForm: FormGroup;
  private userId:string;
  private imageToUpload1 = "assets/images/avatar-4.png";
  private imageToUpload2 = "assets/images/idfront.png";
  private imageToUpload3 = "assets/images/idback.png";
  submitted : boolean = false;
  hasError : boolean ;
  selectedFiles: FileList;
  currentUpload: Upload;
  hasFile: Boolean = false;
  private basePath:string = '/uploads';
  private image;
  editProfile = true;
  editProfileIcon = 'icofont-edit';
  userData : Observable<any>;
  user: any;
  type: any;
  branches: any;
  from:any;
  public sortOrder: string = "desc";
   public sortBy: string = "";
   public data: any;
   public rowsOnPage: number = 10;
   public filterQuery: string = "";
  constructor(private route: ActivatedRoute, public db:AngularFireDatabase, private nf: NotificationToastService, private userService:UserService, private dateService:DateService) {
    var data = this.route.snapshot.queryParamMap.get('key');
    this.from = this.route.snapshot.queryParamMap.get('from');
    this.userId = data;
    this.initializeForm();
   }

  async ngOnInit() {
    this.getUser();
    this.getShipments();
    ///this.getAssignedOrders();
  }

  initializeForm()
  {
    let name = new FormControl('', Validators.required);
      let email = new FormControl('', [Validators.required,Validators.email]);
      let code = new FormControl('', Validators.required);
      let phone = new FormControl('', Validators.required);
      let address = new FormControl('', Validators.required);
      let branch = new FormControl('Select Branch', Validators.required);
  
      this.myForm = new FormGroup({
        name: name,
        email: email,
        code: code,
        phone: phone,
        address: address,
        branch: branch
      });
      var branches = this.userService.getAllBranches();
      branches.snapshotChanges().subscribe(item=>{
        this.branches = [];
        item.forEach(element =>{
          var y = element.payload.toJSON();
            y["$key"] = element.key;
            this.branches.push(y);
        });
      });
    this.edit();
    this.myForm.reset();
  }
  private edit()
  {
    this.db.object('/users/' + this.userId)
    .subscribe(driver =>{
      let name = new FormControl(driver.name, Validators.required);
      let email = new FormControl(driver.email, [Validators.required,Validators.email]);
      let code = new FormControl(driver.code, Validators.required);
      let phone = new FormControl(driver.phoneNumber, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]);
      let address = new FormControl(driver.address, Validators.required);
      let branch = new FormControl(driver.branch, Validators.required);
      if(driver.imageUrl)
      this.imageToUpload1 = driver.imageUrl;
       // Assuming that name is a value of customer you can say
       this.myForm = new FormGroup({
        name:name,
        email:email,
        code:code,
        phone: phone,
        address: address,
        branch: branch
      });
      if(driver.code == "+966")
      {
        this.maxLength = 9;
        this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      }
      else
      {
        this.maxLength = 10;
        this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      }
    });
    
  } 
  phone_error:boolean = false;
onSubmit()
{
this.hasError = false;
this.submitted = true;
//console.log(this.myForm.value);
this.phone_error = false;
    var phone = this.myForm.value.phone;
    if(phone.length != this.maxLength)
      {
        this.phone_error = true;
        return;
      }
else if(this.myForm.valid) {
  //console.log(this.myForm.value);
  var date_time = this.dateService.getTimeandDate();
  var phone = this.myForm.value.phone1;
      var usersRef = firebase.database().ref("users");
      usersRef.child(this.userId).update({
        name: this.myForm.value.name,
        email: this.myForm.value.email,
        code: this.myForm.value.code,
        phoneNumber: this.myForm.value.phone,
        address: this.myForm.value.address,
        branch : this.myForm.value.branch,
        updatedAt: date_time.date,
        updatedTime: date_time.time
      }).then(
        (success) => {
          //console.log("success creation");
          this.submitted = false;
          this.myForm.reset();
          this.currentUpload = null;
          this.nf.addToast({title:'Update Success', msg:'Driver data has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});   
          this.toggleEditProfile(); 
        });
    } 
}
toggleEditProfile() {
  this.editProfileIcon = (this.editProfileIcon === 'icofont-close') ? 'icofont-edit' : 'icofont-close';
  this.editProfile = !this.editProfile;
  if(this.editProfileIcon == 'icofont-edit')
  this.edit();
}
public getUser()
        {
      this.userData = this.db.object("users/"+this.userId);
      this.userData.subscribe(user=>{
      //console.log("userData ",user);
      this.getBranchName(user.branch);
      this.user = user;
      if(user.imageUrl && user.idFrontUrl && user.idBackUrl)
      {
        this.imageToUpload1 = user.imageUrl;
        this.imageToUpload2 = user.idFrontUrl;
        this.imageToUpload3 = user.idBackUrl;
      }
      else if(user.idFrontUrl && user.idBackUrl)
      {
        this.imageToUpload1 = "assets/images/avatar-4.png";
        this.imageToUpload2 = user.idFrontUrl;
        this.imageToUpload3 = user.idBackUrl;
      }
      else{
        this.imageToUpload1 = "assets/images/avatar-4.png";
        this.imageToUpload2 = "assets/images/idfront.png";
        this.imageToUpload3 = "assets/images/idback.png";
      }
    });
        }
      func()
    {
      //this.imageToUpload = "assets/images/avatar-4.png";
      this.image = "assets/images/avatar-4.png";
      this.hasFile = false;
    }
    detectFiles(event,type) {
      this.hasFile = true;
      this.type = type;
      this.selectedFiles = event.target.files;
      //console.log(this.image);
      this.readUrl(event,type);
      }
    readUrl(event:any,type:any) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event:any) => {
          this.image = event.target.result;
          switch(type)
          {
            case 'profile' : this.imageToUpload1 = event.target.result;
            break;
            case 'idFront' : this.imageToUpload2 = event.target.result;
            break;
            case 'idBack' : this.imageToUpload3 = event.target.result;
            break;
          }
        } 
        reader.readAsDataURL(event.target.files[0]);
      }
    }
    uploadPhoto(event)
    {  
  if(this.hasFile && this.selectedFiles.length!=0)
  {
    let file = this.selectedFiles.item(0);
    this.currentUpload = new Upload(file);

    let storageRef = firebase.storage().ref();
    let uploadTask = storageRef.child(`${this.basePath}/${event}/${this.userId}`).put(this.currentUpload.file);

  uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) =>  {
      // upload in progress
      this.currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
    },
    (error) => {
      // upload failed
      //console.log(error)
    },
    () => {
      // upload success
      this.currentUpload.url = uploadTask.snapshot.downloadURL;
      this.currentUpload.name = this.currentUpload.file.name;
     
    //console.log("uploaded "+this.currentUpload.url);
      var data;
      switch(event)
      {
        case "/profileImages":
        data = {
            imageUrl: this.currentUpload.url
          };
          this.updatePhotoUrl("profile");
        break;
        case "/idFront":
        data = {
            idFrontUrl: this.currentUpload.url
          };
          this.updatePhotoUrl("idfront");
        break;
        case "/idBack":
        data = {
          idBackUrl: this.currentUpload.url
        };
        this.updatePhotoUrl("idback");
        break;
      }
    });
    }
  }
updatePhotoUrlOld(data)
{
  
  var usersRef = firebase.database().ref("users");
  usersRef.child(this.userId).update({ 
    data
  }).then(
    (success) => {
      //console.log("image uploaded");
      this.currentUpload = null;
      this.hasFile = false;
      this.image = "assets/images/avatar-4.png";
      this.getUser();
      this.nf.addToast({title:'Update Success', msg:'Profile Photo has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});    
    });
}
updatePhotoUrl(type)
{
  switch(type)
  {
    case "profile":
    var usersRef = firebase.database().ref("users");
  usersRef.child(this.userId).update({ 
    imageUrl: this.currentUpload.url
  }).then(
    (success) => {
      //console.log("image uploaded");
      this.currentUpload = null;
      this.hasFile = false;
      this.getUser();
      this.nf.addToast({title:'Update Success', msg:'Profile Photo has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});    
    });
    break;
    case "idfront":
    var usersRef = firebase.database().ref("users");
  usersRef.child(this.userId).update({ 
    idFrontUrl: this.currentUpload.url
  }).then(
    (success) => {
      //console.log("image uploaded");
      this.currentUpload = null;
      this.hasFile = false;
      this.getUser();
      this.nf.addToast({title:'Update Success', msg:'Id front has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});    
    });
    break;
    case "idback":
    var usersRef = firebase.database().ref("users");
  usersRef.child(this.userId).update({ 
    idBackUrl: this.currentUpload.url
  }).then(
    (success) => {
      //console.log("image uploaded");
      this.currentUpload = null;
      this.hasFile = false;
      this.getUser();
      this.nf.addToast({title:'Update Success', msg:'Id back has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});    
    });
    break;
  }
}
selectedBranch : String = '';
  branchHasError: boolean = false;
  private getSelectedBranch(e)
  {
    this.selectedBranch = e.target.value;
    this.branchHasError = false;
  }
  keyPressUserName(event)
  {
    var format = /[a-zA-Z0-9-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !format.test(inputChar)) {
      event.preventDefault();
    }
  }
  getBranchName(branchid)
  {
    if(branchid)
    {
      firebase.database().ref("branches").child(branchid).once("value").then((branch)=>{
        this.user.branch = branch.child("name").val();
      });
    }
  }
 getShipments()
  {
    var shipments;
    firebase.database().ref("shipments").once("value", (shipment)=>{
      shipments = shipment.val();
      this.getAssignedOrders(shipments);
    });
  }
  assignedOrdersList : AngularFireList<any>;
  ordersEmpty : boolean = false;
  getAssignedOrders(shipments)
  {
    firebase.database().ref("users").child(this.userId).once("value", (user)=>{
      var userData = user.val();
      var orders = [];
      orders = userData.assignedOrders;
      //this.assignedOrdersList = orders;
      this.data = [];
      /* if(orders!=null)
      {
        this.ordersEmpty = true;
        orders.forEach(order=>{
          var y = order;
          y["shipments"] = shipments[order.id];
          this.data.push(y);
        });
        //console.log("assignedOrders",this.assignedOrdersList);
      } */

      for(let i in orders)
      {
        var y = orders[i];
        //console.log(orders[i].id);
        y["shipments"] = shipments[orders[i].id];
        this.data.push(y);
        //console.log("orders ",this.data);
      }
      
    });
  }
  maxLength: number =9;
  onChangeCountry(e)
  {
    //console.log(e.target.value);
    this.phone_error = false;
    //this.myForm.setControl("phone",new FormControl('',Validators.required));
    switch(e.target.value)
    {
      case "+91" : this.maxLength  = 10;
      this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      //console.log(this.maxLength);
      break;
      case "+966" : this.maxLength  = 9;
      this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      //console.log(this.maxLength);
      break;
    }
  }
  private keyPress(event: any) {
    this.phone_error = false;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone = this.myForm.value.phone;
      if(phone.length >= this.maxLength)
      {
        event.preventDefault();
      }
    }
  }
}
/* getAssignedOrders()
{
  firebase.database().ref("users").child(this.userId).once("value", (user)=>{
    var userData = user.val();
    var orders = userData.assignedOrders;
    this.data = [];
    orders.forEach(order=>{
      var y = order;
      firebase.database().ref("shipments").child(order.id).once("value", (shipment)=>{
        y["shipment"] = shipment.val();
      this.data.push(y);
    });
    this.assignedOrdersList = orders;
  });
  //console.log("assignedOrders",this.data);
});
} */



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/drivers/manage-driver/manage-driver.component.ts